import { ref } from 'vue'

/**
 * 轻量消息提示 —— 替代 ElMessage。
 *
 * 队列放在模块作用域（不是 store）：它没有需要持久化或跨标签同步的状态，
 * 放进 Pinia 只会让「登出时要不要清空」变成一个需要讨论的问题。
 */
export type ToastKind = 'success' | 'error' | 'warning' | 'info'

export interface ToastItem {
  id: number
  kind: ToastKind
  text: string
}

const items = ref<ToastItem[]>([])
let seq = 0

/** 错误停留久一点：用户往往要把报错读完甚至复制走。 */
const DURATION: Record<ToastKind, number> = {
  success: 2600,
  info: 2600,
  warning: 4000,
  error: 5200,
}

function push(kind: ToastKind, text: string): void {
  const id = (seq += 1)
  items.value = [...items.value, { id, kind, text }]
  window.setTimeout(() => dismiss(id), DURATION[kind])
}

function dismiss(id: number): void {
  items.value = items.value.filter((t) => t.id !== id)
}

export function useToast() {
  return {
    items,
    dismiss,
    success: (text: string) => push('success', text),
    error: (text: string) => push('error', text),
    warning: (text: string) => push('warning', text),
    info: (text: string) => push('info', text),
  }
}
